import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    Expander,
    ExpanderTheme,
    ExpanderButtonStyle,
    Panel,
    PanelTheme,
    ExpanderExpandedHeaderTheme,
    PanelBorderStyle,
    PanelBorderRadius,
    renderCustomCountExpanderHeader,
    renderCustomIconExpanderHeader,
    ExpanderBorderRoundingStyle,
    ExpanderBorderStyle,
} from '@apply/components';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

export const ExpanderDemo: React.FC<{}> = ({}) => {
    const styles = {
        contentSpacer: {
            marginLeft: 20,
            marginRight: 20,
            height: 'auto',
        },
    };

    const handleButtonCiick: React.MouseEventHandler = useCallback(() => {
        alert('Expander button clicked!');
    }, []);

    return (
        <div style={{ marginTop: '0px', marginBottom: '20px' }}>
            <h2>Expander :</h2>
            <br />
            <Expander
                header={renderCustomCountExpanderHeader(3, 'Expander With Specified Height')}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
                height='80px'
            >
                <div style={styles.contentSpacer}>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        This is panel 1
                    </Panel>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        This is panel 2
                    </Panel>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        This is panel 3
                    </Panel>
                </div>
            </Expander>
            <br />
            <Expander
                header={renderCustomCountExpanderHeader(3, 'Open Items')}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
            >
                <div style={styles.contentSpacer}>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        This is panel 1
                    </Panel>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        This is panel 2
                    </Panel>
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        This is panel 3
                    </Panel>
                </div>
            </Expander>
            <br />
            <Expander
                header={renderCustomCountExpanderHeader(1, 'Initially Expanded Panel')}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
                initialExpanded={true}
            >
                <div style={styles.contentSpacer}>
                    <br />
                    Important things to show below.
                    <br />
                    <br />
                    <Panel
                        theme={PanelTheme.White}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        <li>Thing 1</li>
                        <li>Thing 2</li>
                    </Panel>
                </div>
            </Expander>
            <br />
            <Expander
                header={<h3>Closed Items</h3>}
                theme={ExpanderTheme.Blue}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
                handleClick={handleButtonCiick}
            >
                <div style={styles.contentSpacer}>
                    <br />
                    These are the children of the expander.
                    <br />
                </div>
            </Expander>
            <br />
            <Expander
                header={renderCustomIconExpanderHeader(faExclamationTriangle, '#F93E30', 'Items of Concern')}
                theme={ExpanderTheme.Red}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
            >
                <div style={styles.contentSpacer}>
                    <br />
                    These are the children of the expander.
                </div>
            </Expander>
            <br />
            <Expander
                header={<h3>Bordered Expander</h3>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.Rounded}
                borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
                borderStyle={ExpanderBorderStyle.Solid}
            >
                <div style={styles.contentSpacer}>
                    <Panel
                        theme={PanelTheme.White}
                        borderStyle={PanelBorderStyle.Solid}
                        borderRadius={PanelBorderRadius.Small}
                    >
                        This is content of the panel
                    </Panel>
                    <Panel
                        theme={PanelTheme.Gray}
                        borderRadius={PanelBorderRadius.Small}
                        borderStyle={PanelBorderStyle.Solid}
                    >
                        This is some supplemental content.
                    </Panel>
                    <Panel
                        theme={PanelTheme.Yellow}
                        borderRadius={PanelBorderRadius.Small}
                    >
                        This is some content to warn or inform.
                    </Panel>
                </div>
            </Expander>
            <br />
            <Expander
                width='100%'
                header={<h5>Category 1</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <div style={styles.contentSpacer}>
                    <br />
                    This is more content.
                </div>
            </Expander>
            <Expander
                width='100%'
                header={<h5>Category 2</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <div style={styles.contentSpacer}>
                    <br />
                    This is more content.
                </div>
            </Expander>
            <Expander
                width='100%'
                header={<h5>Category 3</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <div style={styles.contentSpacer}>
                    <br />
                    This is more content.
                </div>
            </Expander>
            <Expander
                width='100%'
                header={<h5>Category 4</h5>}
                theme={ExpanderTheme.White}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                borderRoundingStyle={ExpanderBorderRoundingStyle.NoRounding}
                expandedHeaderTheme={ExpanderExpandedHeaderTheme.Blue}
            >
                <div style={styles.contentSpacer}>
                    <br />
                    This is more content.
                    <br />
                    <br />
                    <Expander
                        height='22px'
                        header={<h5>Additional Item Expander</h5>}
                        buttonStyle={ExpanderButtonStyle.NoRounding}
                        borderRoundingStyle={ExpanderBorderRoundingStyle.Rounded}
                        theme={ExpanderTheme.Gray}
                    >
                        <div style={styles.contentSpacer}>
                            <li>Item 1</li>
                            <li>Item 2</li>
                            <li>Item 3</li>
                        </div>
                    </Expander>
                </div>
            </Expander>
        </div>
    );
};
